import { postPreStartMTDSServiceDesk } from "../request/designordercenter/serviceDesk/preStartMTDSServiceDesk/post.js";
import { postStartMTDSServiceDesk } from "../request/designordercenter/serviceDesk/startMTDSServiceDesk/post.js";
import { selfAxios } from "../axios/selfAxios.js";
import { getEnvMode } from "../utils/currentEnvMode.js";
const FEISHU_SUPPORT_DESK_AUTHORIZATION_URL_MAP = {
  uat: "https://designquotationuat.oppein.com/publicView/feishuSupportDeskAuthorizationPage",
  ver: "https://designquotationver.oppein.com/publicView/feishuSupportDeskAuthorizationPage",
  pro: "https://designquotation.oppein.com/publicView/feishuSupportDeskAuthorizationPage"
};
const FEISHU_SUPPORT_DESK_CHAT_URL = "https://applink.feishu.cn/client/chat/open?openChatId=";
const OAUTH2_ACCESS_TOKEN_HEADER_KEY = "Oauth2-AccessToken";
function getOauth2AccessToken(oauth2AccessToken) {
  var _a, _b;
  if (oauth2AccessToken) {
    return oauth2AccessToken;
  }
  const headerToken = ((_b = (_a = selfAxios.defaults.headers) == null ? void 0 : _a.common) == null ? void 0 : _b[OAUTH2_ACCESS_TOKEN_HEADER_KEY]) || "";
  if (typeof headerToken === "string" && headerToken) {
    return headerToken;
  }
  throw new Error("Oauth2-AccessToken is required when authorization is needed");
}
async function jumpFeishuSupportDesk(params) {
  const { message, Oauth2AccessToken } = params;
  if (!message) {
    throw new Error("message is required");
  }
  console.log("\u8DF3\u8F6C\u98DE\u4E66\u7B54\u7591\uFF0Cmessage\uFF1A", message);
  const hasAuthorized = await postPreStartMTDSServiceDesk();
  if (hasAuthorized) {
    const result = await postStartMTDSServiceDesk({ message });
    const chatId = result == null ? void 0 : result.chatId;
    if (!chatId) {
      throw new Error("\u672A\u83B7\u53D6\u5230\u98DE\u4E66 chatId");
    }
    window.open(`${FEISHU_SUPPORT_DESK_CHAT_URL}${chatId}`, "_blank");
    return;
  }
  const token = getOauth2AccessToken(Oauth2AccessToken);
  const FEISHU_SUPPORT_DESK_AUTHORIZATION_URL = FEISHU_SUPPORT_DESK_AUTHORIZATION_URL_MAP[getEnvMode()];
  if (!FEISHU_SUPPORT_DESK_AUTHORIZATION_URL) {
    throw new Error("\u672A\u627E\u5230\u5BF9\u5E94\u73AF\u5883\u7684\u98DE\u4E66\u6388\u6743\u9875\u5730\u5740");
  }
  const url = `${FEISHU_SUPPORT_DESK_AUTHORIZATION_URL}?message=${encodeURIComponent(message)}&Oauth2-AccessToken=${encodeURIComponent(token)}`;
  window.open(url, "_blank");
}
export { jumpFeishuSupportDesk };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/feishu/jumpFeishuSupportDesk.js